import React from 'react';
import Card from '../../atoms/Card';
import Label from '../../atoms/Label';
import classNames from 'classnames';
import { ReservationAdvanceList } from '../ReservationAdvanceCard';

interface ReservationAdvanceCard {
  title: string;
  itemList: ReservationAdvanceList[];
  hasBorder: boolean;
}

export interface ReservationAdvanceCardListProps {
  cardList: ReservationAdvanceCard[];
}

const ReservationAdvanceCardList: React.FC<ReservationAdvanceCardListProps> = ({ cardList }) => {
  return (
    <Card className='u-flex u-mr16 u-mb16'>
      {cardList.map(({ title, itemList, hasBorder }: ReservationAdvanceCard) => (
        <div
          className={classNames('u-flex u-flex-column u-ws u-mt8 u-mb16', {
            'reservation-advance-card--left-border': hasBorder,
          })}>
          <Card.Header className='u-pt0'>
            <Label className='u-text-m' label={title} data-testid='reservation-advance-card--title' />
          </Card.Header>
          <Card.Content className='u-pb0'>
            {itemList.map((item, index) => {
              const isError = item.label === '未実施' || item.label === '再架電' || item.label === '要確認';
              return (
                <div
                  className={classNames('u-flex', {
                    'u-mb4': itemList.length - 1 !== index,
                  })}
                  key={index}>
                  <Label
                    className={classNames('u-flex-1', {
                      'u-text-danger': isError,
                    })}
                    label={item.label}
                    data-testid={`reservation-advance-card--label-${index}`}
                  />
                  <Label
                    className={classNames('u-text-bold u-text-2l', {
                      'u-text-danger': isError,
                      'u-text-black': !isError,
                    })}
                    label={item.count.toString()}
                    data-testid={`reservation-advance-card--count-${index}`}
                  />
                </div>
              );
            })}
          </Card.Content>
        </div>
      ))}
    </Card>
  );
};
export default ReservationAdvanceCardList;
